// SignUpForm.js
import React, { useState } from 'react';
import NavBar from '../componance/NavBar'; // Import NavBar
import Footer from '../componance/Footer'; // Import Footer

const SignUpForm = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://summerhousagentlive.onrender.com/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          email,
          password,
          phone_number: phoneNumber,
        }),
      });
      const data = await response.json();
      if (data.success) {
        alert('User registered successfully');
        setUsername('');
        setEmail('');
        setPassword('');
        setPhoneNumber('');
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Error registering user');
    }
  };

  return (
    <div style={styles.container}>
      <NavBar />
      <div style={styles.formContainer}>
        <h2 style={styles.heading}>Sign Up</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <input
            type="text"
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Sign Up</button>
        </form>
        {error && <p style={styles.error}>{error}</p>}
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', padding: '20px', paddingTop: '0px',minHeight: '100vh',paddingBottom: '0',
  },

  heading: {
    fontSize: '28px', fontWeight: 'bold', marginBottom: '20px', color: '#2980b9'
  },
  form: {
    width: '100%', display: 'flex', flexDirection: 'column', gap: '15px'
  },
  input: {
    padding: '12px', fontSize: '16px', borderRadius: '8px',
    border: '1px solid #ddd', backgroundColor: '#f9f9f9'
  },
  button: {
    padding: '12px', backgroundColor: '#2980b9', color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer'
  },
  error: {
    color: '#e74c3c', fontSize: '14px', marginTop: '10px'
  },
  link: {
    color: '#2980b9', textDecoration: 'none'
  },
  pageContainer: {
  
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
},
formContainer: {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#fff',
  padding: '30px',
  marginTop: '50px',
  borderRadius: '8px',
  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  width: '100%',
  maxWidth: '400px',
  alignSelf: 'center'
},
};

export default SignUpForm;
